import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ModalService {
    private expenseModalOpen = new BehaviorSubject<{ open: boolean, accountsData: any[], creditCardsData: any[] }>({
        open: false,
        accountsData: [],
        creditCardsData: []
    });
    expenseModalOpen$ = this.expenseModalOpen.asObservable();

    private netWorthTrendModalOpen = new BehaviorSubject<boolean>(false);
    netWorthTrendModalOpen$ = this.netWorthTrendModalOpen.asObservable();

    private investmentOverviewModalOpen = new BehaviorSubject<{ open: boolean, assetName: string }>({ open: false, assetName: '' });
    investmentOverviewModalOpen$ = this.investmentOverviewModalOpen.asObservable();

    private aiChatModalOpen = new BehaviorSubject<boolean>(false);
    aiChatModalOpen$ = this.aiChatModalOpen.asObservable();

    private aiAdviceModalOpen = new BehaviorSubject<boolean>(false);
    aiAdviceModalOpen$ = this.aiAdviceModalOpen.asObservable();

    private budgetStatusModalOpen = new BehaviorSubject<boolean>(false);
    budgetStatusModalOpen$ = this.budgetStatusModalOpen.asObservable();

    private upcomingBillsModalOpen = new BehaviorSubject<boolean>(false);
    upcomingBillsModalOpen$ = this.upcomingBillsModalOpen.asObservable();

    private expenseTrackerModalOpen = new BehaviorSubject<boolean>(false);
    expenseTrackerModalOpen$ = this.expenseTrackerModalOpen.asObservable();

    private accountSummaryModalOpen = new BehaviorSubject<{ open: boolean, accountsData: any[], creditCardsData: any[] }>({
        open: false,
        accountsData: [],
        creditCardsData: []
    });
    accountSummaryModalOpen$ = this.accountSummaryModalOpen.asObservable();

    private savingPlansModalOpen = new BehaviorSubject<boolean>(false);
    savingPlansModalOpen$ = this.savingPlansModalOpen.asObservable();

    // Track selected accounts for expense modal
    private expenseAccountSelection = new BehaviorSubject<any[]>([]);
    expenseAccountSelection$ = this.expenseAccountSelection.asObservable();

    openExpenseModal(accountsData: any[] = [], creditCardsData: any[] = []) {
        this.expenseModalOpen.next({ open: true, accountsData, creditCardsData });
    }

    closeExpenseModal() {
        this.expenseModalOpen.next({ open: false, accountsData: [], creditCardsData: [] });
    }

    openNetWorthTrendModal() {
        this.netWorthTrendModalOpen.next(true);
    }

    closeNetWorthTrendModal() {
        this.netWorthTrendModalOpen.next(false);
    }

    openInvestmentOverviewModal(assetName: string) {
        this.investmentOverviewModalOpen.next({ open: true, assetName });
    }

    closeInvestmentOverviewModal() {
        this.investmentOverviewModalOpen.next({ open: false, assetName: '' });
    }

    openAiChatModal() {
        this.aiChatModalOpen.next(true);
    }

    closeAiChatModal() {
        this.aiChatModalOpen.next(false);
    }

    openAiAdviceModal() {
        this.aiAdviceModalOpen.next(true);
    }

    closeAiAdviceModal() {
        this.aiAdviceModalOpen.next(false);
    }

    openBudgetStatusModal() {
        this.budgetStatusModalOpen.next(true);
    }

    closeBudgetStatusModal() {
        this.budgetStatusModalOpen.next(false);
    }

    openUpcomingBillsModal() {
        this.upcomingBillsModalOpen.next(true);
    }

    closeUpcomingBillsModal() {
        this.upcomingBillsModalOpen.next(false);
    }

    openExpenseTrackerModal() {
        this.expenseTrackerModalOpen.next(true);
    }

    closeExpenseTrackerModal() {
        this.expenseTrackerModalOpen.next(false);
    }

    openAccountSummaryModal(accountsData: any[] = [], creditCardsData: any[] = []) {
        this.accountSummaryModalOpen.next({ open: true, accountsData, creditCardsData });
    }

    closeAccountSummaryModal() {
        this.accountSummaryModalOpen.next({ open: false, accountsData: [], creditCardsData: [] });
    }

    openSavingPlansModal() {
        this.savingPlansModalOpen.next(true);
    }

    closeSavingPlansModal() {
        this.savingPlansModalOpen.next(false);
    }

    updateExpenseAccountSelection(selectedAccounts: any[]) {
        this.expenseAccountSelection.next(selectedAccounts);
    }
}
